import React from 'react';
import { MemberFreeDeliveryDialog } from './member-free-delivery-dialog';
import { EligibleFreeDeliveryDialog } from './eligible-free-delivery-dialog';

interface FreeDeliveryDialogProps {
    open: boolean;
    onClose: () => void;
    onTurnOnPlusClick: () => void;
    isLoyaltyMember?: boolean;
    minimumOrderValue: number;
}

export const FreeDeliveryBenefitsDialog: React.FC<FreeDeliveryDialogProps> = ({
    open,
    onClose,
    onTurnOnPlusClick,
    isLoyaltyMember = false,
    minimumOrderValue,
}) => {
    if (isLoyaltyMember) {
        return (
            <MemberFreeDeliveryDialog
                open={open}
                onClose={onClose}
                minimumOrderValue={minimumOrderValue}
            />
        );
    }

    return (
        <EligibleFreeDeliveryDialog
            open={open}
            onClose={onClose}
            onTurnOnPlusClick={onTurnOnPlusClick}
            minimumOrderValue={minimumOrderValue}
        />
    );
};
